import EventProductsOutsideDates from './EventProductsOutsideDates';
export default EventProductsOutsideDates;
